// Axios
import { serverAPI } from '../../index'

// Action types
export const CHANGE_IMPORTER_SELECTED_FILE = 'change_importer_selected_file'
export const CHANGE_IMPORTER_SELECTED_COMPANY = 'change_importer_selected_company'
export const CHANGE_IMPORTER_CASES = 'change_importer_cases'
export const CHANGE_IMPORTER_STATUS = 'change_importer_status'
export const CHANGE_IMPORTER_SUMMARY = 'change_importer_summary'

export function changeImporterSelectedFile(selectedFile) {
  return {
    type: CHANGE_IMPORTER_SELECTED_FILE,
    payload: selectedFile
  }
}

export function changeImporterSelectedCompany(selectedCompany) {
  return {
    type: CHANGE_IMPORTER_SELECTED_COMPANY,
    payload: selectedCompany
  }
}

export function changeImporterCases(cases) {
  return {
    type: CHANGE_IMPORTER_CASES,
    payload: cases
  }
}

export function changeImporterStatus(status) {
  return {
    type: CHANGE_IMPORTER_STATUS,
    payload: status
  }
}

export function changeImporterSummary(summary) {
  return {
    type: CHANGE_IMPORTER_SUMMARY,
    payload: summary
  }
}
